import axios from 'axios';

export type PageErrorKind = 'offline' | 'emailNotVerified' | 'forbidden' | 'failed';

export interface PageErrorInfo {
  kind: PageErrorKind;
  /** Server-provided message when the API explained the failure. */
  serverMessage: string | null;
}

/**
 * Decide what a broken page should say. A 403 means "not allowed", not
 * "connection dropped", so it must not reuse the generic loading message.
 */
export function describePageError(
  error: unknown,
  offline = false,
): PageErrorInfo {
  if (offline) {
    return {kind: 'offline', serverMessage: null};
  }

  const response = axios.isAxiosError(error) ? error.response : undefined;
  const status =
    response?.status ??
    (typeof (error as any)?.status === 'number' ? (error as any).status : null);
  const data = response?.data as {message?: unknown; code?: unknown} | undefined;
  const serverMessage =
    typeof data?.message === 'string' && data.message.trim() !== ''
      ? data.message
      : null;

  if (status === 403 && data?.code === 'email_not_verified') {
    return {kind: 'emailNotVerified', serverMessage};
  }

  if (status === 403) {
    return {kind: 'forbidden', serverMessage};
  }

  return {kind: 'failed', serverMessage};
}
